import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
interface ICard {
  title?: string;
  onClick?: any;
  Icon?: React.ReactNode;
  actionTool?: React.ReactElement;
}

const Card: React.FC<ICard> = ({
  children,
  title,
  actionTool,
  onClick,
  Icon,
}) => {
  return (
    <button
      className={tw`w-full bg-white p-2 rounded-md mb-8 cursor-pointer focus:outline-none text-left`}
      type="button"
      onClick={onClick}
      style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
    >
      <div>
        <p
          className={tw`uppercase text-primary font-semibold inline-flex text-left  `}
        >
          {Icon}
          <h3>{title}</h3>
        </p>
        <div>{actionTool}</div>
      </div>
      {children}
    </button>
  );
};

export default Card;
